import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Spin, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import ErrorWrapper from '../../../lib/error_wrapper';
import ReconcilerSmartActions from './recon_actions';
import ReconcilerExclusionRules from './recon_exclusion_rules';
import UnReconcilerSmartActions from './unrecon_actions';
import { overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';


const queryString = require('query-string');



const recon_cols = ({ onActionPressed, group_id, onExclusionPressed, onUnreconActionPressed }) => [
    {
        title: "Name",
        dataIndex: "name",
        key: 'name',
        className: 'bold-cell'
    },
    // {
    //     title: "Our Source",
    //     dataIndex: "__references__",
    //     key: 'our_data_type_id',
    //     render: (references = {}) => {
    //         let our_data = references.our_data_type_id || {};
    //         return our_data.name
    //     }
    // },
    {
        title: "Our Service",
        dataIndex: "__references__",
        key: 'our_data_service_id',
        render: (references = {}) => {
            let our_service = references.our_data_service_id || {};
            return our_service.name
        }
    },
    // {
    //     title: "Their Source",
    //     dataIndex: "__references__",
    //     key: 'their_data_type_id',
    //     render: (references = {}) => {
    //         let their_data = references.their_data_type_id || {};
    //         return their_data.name
    //     }
    // },
    {
        title: "Their Service",
        dataIndex: "__references__",
        key: 'their_data_service_id',
        render: (references = {}) => {
            let their_service = references.their_data_service_id || {};
            return their_service.name
        }
    },
    {
        title: "",
        dataIndex: "id",
        key: 'id',
        render: (id) => {
            return <span><Link to={`/settings/groups/reconcilers/${group_id}/rules/edit/${id}`}>
                <Button type='link'>Edit</Button>
            </Link>
                <Button type='link' onClick={() => {
                    typeof onActionPressed === 'function' && onActionPressed(id)
                }}>R-Actions</Button>
                <Divider type='vertical' />
                <Button type='link' onClick={() => {
                    typeof onUnreconActionPressed === 'function' && onUnreconActionPressed(id)
                }}>U-Actions</Button>
                {/* <Divider type='vertical'/>
            <Button type='link' onClick={()=>{
                typeof onExclusionPressed==='function'&&onExclusionPressed(id)
            }}>Exclusions</Button> */}
            </span>
        }
    },

]
class ReconcilerGroupDetail extends Component {
    constructor(props) {
        super(props)

        this.group_id = props.match.params.group_id;

        this.state = {
            edit_id: null,
            form_data: {},
            action_drawer_visibility: false,
            unrecon_action_drawer_visibility: false,
            current_recon_id: null,
            reconciler_group_obj: {},
            loading: true,
            filter_query: {}

        };

        this.detail_reconciler_group = RESTExecutor.detail().config({
            label: 'reconciler_group_detail'
        }).callbacks((success) => {
            this.setState({
                loading: false, reconciler_group_obj: success.result
            });
            this.list_reconcilers.forId(this.group_id).config({
                params: {
                    ...this.state.filter_query
                }
            }).execute();
        }, (error) => {
            this.setState({ loading: false })
        }).connect(props.domains.settings);


        this.list_reconcilers = RESTExecutor.list().config({
            label: 'reconciler_rules',
            params: {
                per_page: 100
            }
        }).forId(this.group_id).connect(props.domains.settings);


        this.delay_search = new NetworkDelaySearch();

    };

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }


    render() {
        let list_reconcilers_resp = this.list_reconcilers.response();
        let list_reconcilers_data = list_reconcilers_resp.result || {};
        let reconcilers_list = list_reconcilers_data.rows || [];

        let rowsMeta = list_reconcilers_resp.meta || {};
        const { reconciler_group_obj, loading, filter_query } = this.state;
        let detail_reconciler_group_resp = this.detail_reconciler_group.response();
        if (loading) {
            return <center><Spin /></center>
        }

        return (
            <div>
                <ErrorWrapper
                    error={detail_reconciler_group_resp}
                    onReload={() => {
                        this.setState({ loading: true })
                        this.detail_reconciler_group.forId(this.group_id).execute()
                    }}
                >


                    <BasicHeader
                        title={reconciler_group_obj.name}
                        titleType="Processor"
                        subtitle="Rules"
                        right={[
                            <Link to={`/settings/groups/reconcilers/${this.group_id}/rules/add`}>
                                <TransparentButton
                                    label="Add New"
                                    className='cta-primary'
                                    hint="Add New Rule"
                                /></Link>,
                        ]}

                    />

                    <div className='filter-card'>
                        <div className='filter-card-top' style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            flexWrap: 'nowrap',

                        }}>
                            <Input.Search
                                placeholder="Search For"
                                style={{
                                }} autoFocus
                                value={filter_query.query}
                                onChange={(e) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                            this.delay_search.onSearch(() => {

                                                this.props.history.push({
                                                    // pathname:"users",
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            })

                                        }
                                    })
                                }} />
                        </div>
                    </div>
                    <ErrorWrapper
                        error={list_reconcilers_resp}
                        onReload={() => {
                            this.list_reconcilers.execute()
                        }}
                    >
                        <div className='default-card' style={{
                            padding: 0
                        }}>
                            {/* <CustomHeader/> */}
                            <Table
                                scroll={{ x: true }}
                                dataSource={reconcilers_list}
                                className='main-table'
                                loading={list_reconcilers_resp.fetching}
                                columns={recon_cols({
                                    onActionPressed: (id) => {
                                        this.setState({
                                            action_drawer_visibility: true,
                                            current_recon_id: id
                                        })
                                    },
                                    onUnreconActionPressed: (id) => {
                                        this.setState({
                                            unrecon_action_drawer_visibility: true,
                                            current_recon_id: id
                                        })
                                    },
                                    // onExclusionPressed:(id)=>{
                                    //     this.setState({
                                    //         exclusion_drawer_visibility:true,
                                    //         current_recon_id:id
                                    //     })
                                    // },
                                    group_id: this.group_id
                                })}
                                size='small'
                                rowKey={(record) => record.id}
                                pagination={{
                                    simple: false,
                                    position: 'bottom',
                                    onChange: (current, size) => {
                                        this.list_reconcilers.config({
                                            params: {
                                                per_page: size,
                                                page: current
                                            }
                                        }).execute();
                                    },
                                    defaultCurrent: 1,
                                    current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                    // defaultPageSize: 20,
                                    pageSize: (rowsMeta && rowsMeta.requested_count),

                                    total: (rowsMeta && rowsMeta.total_count),
                                    showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                                }}
                            />

                            <Drawer
                                title={<Title style={{ margin: 0 }}>Processed Smart Actions</Title>}
                                placement="right"
                                closable={true}
                                width='60%'
                                destroyOnClose
                                onClose={() => {
                                    this.setState({
                                        action_drawer_visibility: false,
                                        current_recon_id: null
                                    })
                                }}
                                visible={this.state.action_drawer_visibility}
                            >
                                <ReconcilerSmartActions
                                    // key={`-${this.state.current_recon_id}`}
                                    recon_id={this.state.current_recon_id}
                                />
                            </Drawer>

                            <Drawer
                                title={<Title style={{ margin: 0 }}>Unprocessed Smart Actions</Title>}
                                placement="right"
                                closable={true}
                                width='60%'
                                destroyOnClose
                                onClose={() => {
                                    this.setState({
                                        unrecon_action_drawer_visibility: false,
                                        current_recon_id: null
                                    })
                                }}
                                visible={this.state.unrecon_action_drawer_visibility}
                            >
                                <UnReconcilerSmartActions
                                    // key={`-${this.state.current_recon_id}`}
                                    recon_id={this.state.current_recon_id}
                                />
                            </Drawer>


                        </div>
                    </ErrorWrapper>
                </ErrorWrapper>
            </div>
        );
    }
    // componentDidMount() {
    //     this.list_reconcilers.execute();

    //     try{
    //         window.header_assigner.assignTitle("Rules");

    //     }catch(e){}
    // }

    componentDidMount() {


        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query,
            }
        }, () => {
            this.detail_reconciler_group.forId(this.group_id).execute()
        })
        // this.list_reconcilers.execute();

    }

    componentWillReceiveProps(nextProps) {
        var oldgroup_id = this.props.match.params.group_id;
        var newgroup_id = nextProps.match.params.group_id;


        if (oldgroup_id !== newgroup_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.group_id = newgroup_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...parsed
                },
            }, () => {
                if (oldgroup_id !== newgroup_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.detail_reconciler_group.forId(this.group_id).execute();
                    })
                } else {
                    this.list_reconcilers.forId(this.group_id).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }
            })

        }
    }

    // componentDidUpdate = (prevProps) => {
    //     if (this.props.match.params.group_id !== prevProps.match.params.group_id) {
    //         this.group_id = this.props.match.params.group_id;

    //         this.list_reconcilers.forId(this.group_id).execute()
    //         // fetch the new product based and set it to the state of the component
    //     };
    // };

}

export default withDomains(ReconcilerGroupDetail, "settings");